<template>
  <div id="container">
    <div class="sub-title"><i class="el-icon-timer"></i> 系统概况</div>
    
    <div class="showCon">
   
    <div id="echartsContainer"> 
      <div class="left">
         <div class="detail">
            <h3>速率状态</h3>
            <p> <b class="top">↑</b> 上传速率 {{value.uploadSpeed}} kb/s</p>
            <p> <b class="bottom">↓</b> 下载速率 {{value.downloadSpeed}} kb/s</p>
         </div>
         <div class="detail">
            <h3>磁盘IO</h3>
            <p>读取速率 {{value.read}} kb/s</p>
            <p>写入速率 {{value.write}} kb/s</p>
         </div>
         <div class="detail">
            <h3>并发数</h3>
            <p>1vs1: {{value.concurrent1vs1}} / {{value.concurrent1vs1Init}}</p>
            <p>1vsN: {{value.concurrent1vsn}} / {{value.concurrent1vsnInit}}</p>
            <p>1vsV: {{value.concurrent1vsv}} / {{value.concurrent1vsvInit}}</p>
         </div>
      </div>
      <div id="parent">
        <div class="detail">
          <span class="title">硬盘占用</span>
          <span
            >{{ (value.usedDisk) &&(value.usedDisk).toFixed(2) }} GB /
            {{ (value.totalDisk) && (value.totalDisk).toFixed(2) }} GB</span
          >
        </div>
        <div id="diskPieContainer"></div>
      </div>
      <div id="parent">
        <div class="detail">
          <span class="title">内存占用  {{(value.usedMemory) && (value.usedMemory/1024).toFixed(2) }} GB /
            {{ (value.totalMemory) && (value.totalMemory/1024).toFixed(2) }}GB</span>
          <span class="title">本进程内存占用  {{(value.memoryUsage) && (value.memoryUsage/1024).toFixed(2) }}</span>
        </div>
         
        <div id="memoryPieContainer"></div>
      </div>
      <div id="parent">
        <div class="detail">
          <span class="title">CPU利用率 {{
              value.cpuUsage && value.cpuUsage.toFixed(2)
            }}% / {{
              value.cpuCoreCount && value.cpuCoreCount.toFixed(2)
            }}%</span>
            <span class="title">cpu负载 {{
              value.cpuLoad && value.cpuLoad.toFixed(2)
            }}%</span>
        </div>
        <div id="cpuPieContainer"></div>
      </div>
    </div>
     </div>
  
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      diskPie: null,
      memoryPie: null,
      cpuPie: null,
      value: {
        usedDisk: "",
        totalDisk: "", //UsedDisk/TotalDisk  磁盘占用
        usedMemory: "",
        totalMemory: "",
        memoryUsage:'', //UsedMemory/TotalMemory 内存占用
        cpuLoad: "", //cpu
        cpuCoreCount:'',
        cpuUsage:'',
        uploadSpeed:'',//速率-上传
        downloadSpeed:'',//下载
        read:'', //磁盘-读
        write:'',//磁盘-写
        concurrent1vs1:'', //1vs1
        concurrent1vs1Init:'',
        concurrent1vsn:'',//1vsn
        concurrent1vsnInit:'',
        concurrent1vsv:'', //1vsv
        concurrent1vsvInit:'',
        // threadCount:'', //使用线程数
        responseTime:'',
      },
      timer: null,
    };
  },
  created() {
     this.getDataHandle();
    this.timer = setInterval(() => {
      this.getDataHandle();
    }, 5000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
    window.onresize = null
  },
  mounted() {
    window.onresize = this.reDrawGraph
  },
  methods: {
    //获取数据
    async getDataHandle() {
      let resultObj = await this.$request(this.$api.computer.systemInfo());
      this.value = { ...resultObj };
      this.diskPieHandle();
      this.memoryPieHandle();
      this.cpuPercentHandle();
    },
    //
    diskPieHandle() {
      const diskPieChartDom = document.getElementById("diskPieContainer");
      this.diskPie = echarts.init(diskPieChartDom);
      const option = {
        tooltip: {
          trigger: "item",
          textStyle: {
            fontSize: 16,
          },
          formatter: function (a) {
            var str = a.name + ":" + (a.value / 1024).toFixed(2) + "GB";
            return str;
          },
        },
        title: {
          text:
            ((this.value.usedDisk / this.value.totalDisk) * 100).toFixed() +
            "%",
          itemGap: 40,
          x: "center",
          y: "center",
          top: "170",
          textStyle: {
            fontSize: "40",
            color: "#606266",
          },
        },
        color: ["#36c1cd", "#ccc"],
        legend: {
          top: "10%",
          left: "10px",
          textStyle: {
            fontSize: 16,
          },
        },
        series: [
          {
            name: "磁盘占用",
            type: "pie",
            radius: ["45%", "65%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "60",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: this.value.usedDisk, name: "已用" },
              {
                value: this.value.totalDisk - this.value.usedDisk,
                name: "剩余",
              },
            ],
          },
        ],
      };

      option && this.diskPie.setOption(option);
    },
    memoryPieHandle() {
      const memoryPieChartDom = document.getElementById("memoryPieContainer");
      this.memoryPie = echarts.init(memoryPieChartDom);
      const option = {
        tooltip: {
          trigger: "item",
          textStyle: {
            fontSize: 16,
          },
          formatter: function (a) {
            var str = a.name + ":" + (a.value / 1024).toFixed(2) + "GB";
            return str;
          },
        },
        title: {
          text:
            ((this.value.usedMemory / this.value.totalMemory) * 100).toFixed() +
            "%",
          itemGap: 40,
          x: "center",
          y: "center",
          top: "170",
          textStyle: {
            fontSize: "40",
            color: "#606266",
          },
        },
        color: ["#36c1cd", "#ccc"],
        legend: {
          top: "5%",
          left: "10px",
          textStyle: {
            fontSize: 16,
          },
        },
        series: [
          {
            name: "内存占用",
            type: "pie",
            radius: ["45%", "65%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "60",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: this.value.usedMemory, name: "已用" },
              {
                value: this.value.totalMemory - this.value.usedMemory,
                name: "剩余",
              },
            ],
          },
        ],
      };

      option && this.memoryPie.setOption(option);
    },
    cpuPercentHandle() {
      const cupPieChartDom = document.getElementById("cpuPieContainer");
      this.cpuPie = echarts.init(cupPieChartDom);
      const option = {
        tooltip: {
          trigger: "item",
          textStyle: {
            fontSize: 16,
          },
          formatter: function (a) {
            var str = a.name + ":" + a.value.toFixed() + "%";
            return str;
          },
        },
        title: {
          text: this.value.cpuLoad.toFixed() + "%",
          itemGap: 40,
          x: "center",
          y: "center",
          top: "170",
          textStyle: {
            fontSize: "40",
            color: "#606266",
          },
        },
        color: ["#36c1cd", "#ccc"],
        legend: {
          top: "5%",
          left: "10px",
          textStyle: {
            fontSize: 16,
          },
        },
        series: [
          {
            name: "内存占用",
            type: "pie",
            radius: ["45%", "65%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "60",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: this.value.cpuLoad, name: "已用" },
              {
                value: 100 - this.value.cpuLoad,
                name: "剩余",
              },
            ],
          },
        ],
      };

      option && this.cpuPie.setOption(option);
    },
    reDrawGraph() {
     this.diskPie&& this.diskPie.resize();
     this.memoryPie && this.memoryPie.resize();
     this.cpuPie&& this.cpuPie.resize();
    },
  },
};
</script>

<style lang="less" scoped>
#container {
  width: 100%;
  height: 100%;
  .showCon{
    width:100%;
    height: 90%;
    display: flex;
    align-items: center;
    // padding: 20px;
    box-sizing: border-box;
    background: #fff;
    color:#606266;
  
    #echartsContainer {
      width: 100%;
      height: 90%;
      background: #fff;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      overflow: hidden;
      .left{
       width:23%;
       height: 500px;
        border: 1px solid #ebeef5;
        box-shadow: 0 2px 12px #ccc;
        padding:0 10px;
        .detail{
          border-bottom:1px solid #ccc;
          p{
             .top{
                color:pink
             }
             .bottom{
                color:#36c1cd;
             }
          }
        }
        .detail:last-child{
           border-bottom: none;
        }
      }
      #parent {
        width: 23%;
        height: 500px;
        background: #fff;
        border: 1px solid #ebeef5;
        box-shadow: 0 2px 12px #ccc;
        display: flex;
        flex-direction: column;
        #diskPieContainer,
        #memoryPieContainer,
        #cpuPieContainer {
          width: 100%;
          height: 400px;
          margin-top: 20px;
          display: flex;
          justify-content: center;
        }
        .detail {
          width: 100%;
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-content: left;
          color: #606266;
          padding-left: 15px;
          border-bottom: 1px solid #ebeef5;
          span {
            font-size: 18px;
            margin-top: 15px;
          }
          .title {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>